<button
  type="button"
  [disabled]="disabled()"
  [ngStyle]="chipStyles()"
  [ngClass]="chipClasses()"
  (click)="toggleSelection()"
  class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 transition-all duration-200 bg-(--chip-bg) border-(--chip-stroke) cursor-pointer"
>
  <span class="text-sm uppercase leading-none tracking-wide text-(--chip-text)">{{ label() }}</span>

  @if (mode() === optionChipMode.MULTIPLE) {
    <bevvi-icon
      [icon]="selected() ? iconsEnum.TICK : iconsEnum.PLUS"
      [size]="iconSize.XS"
      class="text-(--chip-text)"
    />
  }
</button>
